import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe, formatDate } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomerService } from '../_services/customer.service';
import { AccountService } from '../_services/account.service';
import { InvoicesService } from '../_services/invoices.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { ExcelService } from '../_helpers/index';

import { ParameterData } from '../_helpers/index';
import { Router, ActivatedRoute } from '@angular/router';
import { accountPSPCreation, accountPSPType, accountPSPStatus } from '../_enums/account';
import { DataService } from '../_helpers/dataservice.service'
import { PaymentProcess } from '../_models';
import { AuthService } from '../_services/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'accountsoperationbank',
  templateUrl: './accountoperationpsp.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css']
})

export class AccountsOperationPspComponent implements OnInit, OnDestroy {

  public customer_public_id: string;
  public customer_Account_public_id: string;

  excelExportData: any;
  ddlStatus: any[];
  ddlAccountType: any[];
  ddlAccountCreation: any[];

  searchFilterForm: FormGroup;
  searchRangoFilterForm: FormGroup;
  displayedColumns: string[] = ['select', 'created', 'description', 'total', 'reference', 'type', 'metadata.debtor.name', 'status'];
  dataSourceAccOperationPSPList = new MatTableDataSource();
  selection = new SelectionModel<any>(true, []);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  filterValue;
  customerPublic_key;
  isRangoVisiable = false;
  auth0Profile: any;

  cust_account_name: any;
  /** This is Constructor function which is used to initialize the class variables and objects; 
   */
  constructor
    (
      private router: Router, private formBuilder: FormBuilder, private _fb: FormBuilder, private excelService: ExcelService
      , private parameterData: ParameterData, private dataService: DataService
      , private customerService: CustomerService
      , private invoicesService: InvoicesService
      , private datePipe: DatePipe
      , private accountService: AccountService
      , private auth: AuthService
      , private readonly activatedRoute: ActivatedRoute
      , private _accountpspcreation: accountPSPCreation
      , private _acctype: accountPSPType
      , private _accStatus: accountPSPStatus
      , private spinnerService: Ng4LoadingSpinnerService
    ) {

    this.spinnerService.show();

    this.ddlStatus = _accStatus._accountPSPStatus;
    this.ddlAccountCreation = _accountpspcreation._accountpspcreation;
    this.ddlAccountType = _acctype._accountPSPType;

  }//end 




  /** This function is used to work the text filter above the grid; 
   */
  applyFilter() {

    this.filterValue = this.searchFilterForm.controls.searchText.value;
    this.filterValue = this.filterValue.trim();
    this.filterValue = this.filterValue.toLowerCase();
    this.dataSourceAccOperationPSPList.filter = this.filterValue;
  }//end


  /** This is ngOnInit function called after initialising the component; 
 */
  ngOnInit() {


    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');

      }
    }
    else {
      this.customer_public_id = localStorage.getItem('subcompanyId');

    }


    //////////////////////////


    //used to retrieve the customer Account public id
    let params: any = this.activatedRoute.snapshot.params;
    this.customer_Account_public_id = params.id;


    this.searchFilterForm = this.formBuilder.group({
      searchText: ['', Validators.required]
    });

    this.searchRangoFilterForm = this._fb.group({
      searchFromDate: [''],
      searchToDate: ['']
    });

    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";

    this.GetAccountsDetails();
    this.GetCustomerAccountsOperationPSPList();
    this.dataSourceAccOperationPSPList.paginator = this.paginator;
    this.dataSourceAccOperationPSPList.sort = this.sort;

  }//end

  ngOnDestroy() {

  }//end


  /** This function is used to get the invoices list from the service; 
 * it accepts the param customerId
 */
  GetCustomerAccountsOperationPSPList() {
    this.accountService.getAccountOperationListPSPNew(this.customer_Account_public_id).subscribe(data => {
      let resources = data["data"];
      this.dataSourceAccOperationPSPList.data = resources;
      this.excelExportData = resources;

    },
      error => {
        console.log('Failed! while trying to get the accounts operations psp list. ' + error);
      });
  }//end



  /** This function is used to get the account account details from the service; 
   * it accepts the param account public id
   */
  GetAccountsDetails() {
    this.accountService.getAccount(this.customer_Account_public_id).subscribe(data => {
      this.cust_account_name = data.name;
    },
      error => {
        console.log('Failed! while trying to get the acccount details list. ' + error);
      });
  }//end



  /** This function is used to export the invoices list to the excel file; 
   * it reads the data from the variable excelExportData which is assigened when the lits bind in to the grid
   */
  exportAsXLSX() {
    this.excelService.exportAsExcelFile(this.excelExportData, 'InvoicesList');
  }//end




  /** This function is used to filter the Account list based on Creation Detail wise; 
   * it accepts the param select status value
   */
  filterAccountTypeDetails(accounttype) {

    if (accounttype == this.ddlAccountType[0].value) {
      this.dataSourceAccOperationPSPList.filter = '';
    }
    else {
      this.dataSourceAccOperationPSPList.filter = '';
      this.dataSourceAccOperationPSPList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.psp_operation.type == accounttype;
      this.dataSourceAccOperationPSPList.filter = accounttype;
    }

  }//end


  /** This function is used to filter the Account list based on Status Detail wise; 
   * it accepts the param select status value
   */
  filterAccountStatusDetails(status) {

    if (status == this.ddlStatus[0].value) {
      this.dataSourceAccOperationPSPList.filter = '';
    }
    else if (status == this.ddlStatus[1].value) {
      this.dataSourceAccOperationPSPList.filter = '';

      this.dataSourceAccOperationPSPList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.status.toLowerCase() == 'NEW';

      this.dataSourceAccOperationPSPList.filter = 'NEW';
    }
    else if (status == this.ddlStatus[2].value) {
      this.dataSourceAccOperationPSPList.filter = '';
      this.dataSourceAccOperationPSPList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.status == 'CONFIRMED';

      this.dataSourceAccOperationPSPList.filter = 'CONFIRMED';
    }
    else if (status == this.ddlStatus[3].value) {
      this.dataSourceAccOperationPSPList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.status == 'CANCELLED';

      this.dataSourceAccOperationPSPList.filter = 'CANCELLED';
    }

  }//end


  /*
  * This function is used to filter the invoices list based on Creation details based; 
  * it accepts the param select Creation Date values      
  */

  filterAccountCreationDetails(creation) {

    var currentDate = new Date();

    var currentweekFirstDate = new Date();
    var currentweekLastDate = new Date();

    var lastweekFirstDate = new Date();
    var lastweekLastDate = new Date();

    currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
    currentweekLastDate.setDate(currentweekFirstDate.getDate() + 7);

    var currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    var currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    var lastmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    var lastmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    lastweekFirstDate.setDate(currentweekFirstDate.getDate() - 7);
    lastweekLastDate.setDate(lastweekFirstDate.getDate() + 6);



    // All Datas Condition
    if (creation == 0) {
      this.dataSourceAccOperationPSPList.filter = '';
    }

    // Current Month Filter Condition
    if (creation == 1) {
      this.dataSourceAccOperationPSPList.filter = '';
      let CurrentmonthFirstDate = formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let CurrentmonthEndDate = formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceAccOperationPSPList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.created >= CurrentmonthFirstDate && data.created <= CurrentmonthEndDate;

    }

    // Current Week Filter Condition
    if (creation == 2) {
      this.dataSourceAccOperationPSPList.filter = '';
      let WeekstartDate = formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let WeekendDate = formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceAccOperationPSPList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.created >= WeekstartDate && data.created <= WeekendDate;

    }

    // Today Filter Condition
    if (creation == 3) {
      this.dataSourceAccOperationPSPList.filter = '';
      currentDate.setDate(currentDate.getDate());
      let startDate = formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let endDate = formatDate(currentDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceAccOperationPSPList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.created >= startDate && data.created <= endDate;
    }

    // Yesterday Filter Condition
    if (creation == 4) {
      this.dataSourceAccOperationPSPList.filter = '';
      currentDate.setDate(currentDate.getDate() - 1);
      let startDate = formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let endDate = formatDate(currentDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceAccOperationPSPList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.created >= startDate && data.created <= endDate;
    }


    // Last Week Filter Condition
    if (creation == 5) {
      this.dataSourceAccOperationPSPList.filter = '';

      let lastWeekstartDate = formatDate(lastweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let lastWeekendDate = formatDate(lastweekLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');


      this.dataSourceAccOperationPSPList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.created >= lastWeekstartDate && data.created <= lastWeekendDate;

    }

    // Last Month Filter Condition
    if (creation == 6) {
      this.dataSourceAccOperationPSPList.filter = '';
      let LastmonthFirstDate = formatDate(lastmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let LastmonthEndDate = formatDate(lastmonthLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceAccOperationPSPList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.created >= LastmonthFirstDate && data.created <= LastmonthEndDate;

    }
    if (creation != 0) {
      this.dataSourceAccOperationPSPList.filter = '2018-10-24 01:59:45';
    }


    // Range Filter Condition
    if (creation == 7) {
      this.isRangoVisiable = true;
    }
    else {
      this.isRangoVisiable = false;
    }
  }//end

}//end class


